// @ts-strict-ignore
import React from 'react';
import { Icon, IconName } from '@usealloy/component-library';
import type { WorkflowState } from '~/dashboard/views/workflows/store/redux/state';
import type { PublishedAttributeActionTypes, ReplaceWithPublishedAttributeOption } from './types';
import type { PublishedAttribute } from 'flow/store/engine/types';
import { formatObjectType } from '~/dashboard/views/settings/published-attributes/utils';
import { PublishedAttributeOwnerType } from '~/dashboard/views/settings/published-attributes/types';
import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';

export function buildPublishedAttributeOptions(
  actionType: PublishedAttributeActionTypes,
  publishedAttributes: PublishedAttribute[],
  publishedAttributesInWorkflow: WorkflowState['workflowData']['actions'][string][],
): ReplaceWithPublishedAttributeOption[] {
  const tokensOfPublishedAttributesInWorkflow = publishedAttributesInWorkflow
    .reduce((tokens, pa) => {
      tokens.add(pa[actionType].publishedAttributeToken);
      return tokens;
    }, new Set<string>());

  return publishedAttributes
    // System PAs are managed by Alloy and cannot be written to; never offer them as output targets.
    .filter(pa => actionType !== ActionType.OUTPUT
      || pa.ownerType !== PublishedAttributeOwnerType.SYSTEM)
    .map(pa => {
      const { attributeName, attributeToken, objectType } = pa;
      return {
        label: `${attributeName} (${formatObjectType(objectType)})`,
        value: attributeToken,
        disabled: tokensOfPublishedAttributesInWorkflow.has(attributeToken),
        icon: <Icon icon={IconName.Bookmark} />,
      };
    }).sort((a, b) => a.label.localeCompare(b.label));
}
